var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLinkednLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.915,
    cy: 12.02,
    rx: 11.915,
    ry: 11.81,
    fill: "#007AB9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.915,
    cy: 12.02,
    rx: 11.915,
    ry: 11.81,
    fill: "#5F787E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36 5.257c-.974 0-1.611.634-1.611 1.466 0 .816.619 1.468 1.574 1.468h.019c.993 0 1.61-.652 1.61-1.468-.018-.832-.617-1.466-1.591-1.466zm11.674 7.714v4.869h-2.848v-4.543c0-1.14-.412-1.92-1.443-1.92-.787 0-1.254.525-1.46 1.033-.076.181-.095.433-.095.688v4.742H10.34s.038-7.694 0-8.49h2.848v1.202c-.002.005-.006.01-.009.014l-.01.014h.02v-.028c.378-.577 1.053-1.402 2.566-1.402 1.874 0 3.278 1.213 3.278 3.82zM8.764 17.84H5.918V9.35h2.847v8.49z",
    fill: "#fff"
  })));
}
export default SvgMobileLinkednLogo;